import React, { createContext, useContext, useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { LOGO as DEFAULT_LOGO } from "@/lib/brand";

const DEFAULTS = {
  hero_subtitle: "Stream nonstop gospel, praise & worship stations. Tune in, save your favorites, request songs and join the live chat.",
  hero_heading: "Worship on the airwaves, anytime.",
  hero_highlight: "airwaves",
  hero_cta: "Start Listening",
  brand_primary: "#E6B34A",
  guest_card_title: "Make it yours — free forever.",
  guest_card_highlight: "free forever",
  guest_card_body: "Create a free account to save favorites, request songs, join the live chat and get alerts the moment we go live.",
  featured_hosts: [],
  has_logo: false,
  logo_url: null,
};

const BrandContext = createContext({ ...DEFAULTS, logo: DEFAULT_LOGO, refresh: () => {} });

export function BrandProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = () => api.get("/settings").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {});
  useEffect(() => { refresh(); }, []);

  useEffect(() => {
    if (settings.brand_primary) {
      document.documentElement.style.setProperty("--brand", settings.brand_primary);
    }
  }, [settings.brand_primary]);

  const logo = settings.has_logo && settings.logo_url ? `${API}${settings.logo_url.replace("/api", "")}` : DEFAULT_LOGO;

  return <BrandContext.Provider value={{ ...settings, logo, refresh }}>{children}</BrandContext.Provider>;
}

export const useBrand = () => useContext(BrandContext);
